import { MotionConfig } from "framer-motion";
import { Experience } from "@/components/Experience";
import AnnouncementBanner from "@/components/AnnouncementBanner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TrustMarquee from "@/components/TrustMarquee";
import VisionMission from "@/components/VisionMission";
import Services from "@/components/Services";
import TrainingDelivery from "@/components/TrainingDelivery";
import PostTrainingSupport from "@/components/PostTrainingSupport";
import Process from "@/components/Process";
import Faq from "@/components/Faq";
import EnquiryForm from "@/components/EnquiryForm";
import Footer from "@/components/Footer";

export default function HomePage() {
  return <MotionConfig reducedMotion="user"><Experience><div data-testid="home-page"><a className="skip-link" href="#main-content" data-testid="skip-to-content">Skip to content</a><AnnouncementBanner /><Navbar /><main id="main-content" tabIndex={-1}><Hero /><TrustMarquee /><VisionMission /><Services /><TrainingDelivery /><PostTrainingSupport /><Process /><Faq /><EnquiryForm /></main><Footer /></div></Experience></MotionConfig>;
}